import {
  Navigate,
  Outlet,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom"
import HomePage from "@/pages/HomePage"
import LogoutPage from "@/pages/LogoutPage"
import Calendar from "@/pages/CalendarPage"
import ListPage from "@/pages/ListPage"
import Profile from "@/pages/Profile"
import AboutUs from "@/pages/AboutUs"
import Cookies from "js-cookie"
import AdminEvents from "@/pages/AdminEvents"
// import AttractionsPage from "@/pages/AttractionsPage"
import Layout from "@/components/Layout"

export const ProtectedRoute = () => {
  const token = Cookies.get("sessionToken")
  // Check if the user is authenticated
  if (!token) {
    // If not authenticated, redirect to the login page
    return <Navigate to="/" />
  }

  // If authenticated, render the child routes
  return <Outlet />
}

export const routesForPublic = [
  {
    order: 1,
    label: "Map",
    path: "/",
    element: <HomePage />,
  },
  {
    order: 2,
    label: "Calendar",
    path: "/calendar/:year?/:month?",
    element: <Calendar />,
  },
  {
    order: 3,
    label: "List",
    path: "/list",
    element: <ListPage />,
  },
  {
    order: 7,
    label: "About Us",
    path: "/about-us",
    element: <AboutUs />,
  },
  // {
  //   order: 8,
  //   label: "Attractions",
  //   path: "/attractions",
  //   element: <AttractionsPage />,
  // },
]

export const routesForAuthenticatedOnly = [
  {
    // label: "Protected Route",
    path: "/",
    element: <ProtectedRoute />,
    children: [
      {
        order: 4,
        label: "Profile",
        path: "/profile",
        element: <Profile />,
      },
      {
        order: 5,
        label: "Logout",
        path: "/logout",
        element: <LogoutPage />,
      },
      {
        order: 6,
        label: "Events",
        path: "/admin/*",
        element: <AdminEvents />,
      },
    ],
  },
]

export const routesForNotAuthenticatedOnly = [
  // {
  //   order: 1,
  //   label: "Map",
  //   path: "/",
  //   element: <HomePage />,
  // },
]

export const Router = () => {
  const token = Cookies.get("sessionToken")

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        ...routesForPublic,
        ...(!token ? routesForNotAuthenticatedOnly : []),
        ...routesForAuthenticatedOnly,
      ],
    },
  ])

  return <RouterProvider router={router} />
}

export default Router
